<atn-ds-table [config]="packagesTableConfig" />
